import * as actions from '../actions/userActions';

const initialState = {
  isLoading: true,
  profile: false,
  balance: null,
  balanceCash: null,
  wallets: {},
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PROFILE: {
      return {
        ...state,
        isLoading: false,
        profile: action.profile,
      };
    }
    case actions.SET_GUEST: {
      return {
        ...state,
        isLoading: false,
        profile: false,
      };
    }
    case actions.SET_BALANCE: {
      return {
        ...state,
        balance: Math.floor(action.balance),
        balanceCash: Math.floor(action.balanceCash),
      };
    }
    case actions.SET_WALLETS: {
      return {
        ...state,
        wallets: action.wallets,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/user.js